import { NAVIGATION_FROM_APP_CODE } from "../constants/common";
import { APP_CODE_TYPE } from "../models/auth";
import { getCookieValue } from "./helper";
import getClientCode from "./helpers/getClientCode";
import { getMixpanelObj } from "./mixpanel";
import Config from "app/utils/config";

/**
 * responsible to send event to mix panel
 * @param  {string} eventName event name
 * @param  {Record<string, any>} eventData? event data
 * @param  {boolean} addCrop? add crop ids to event data
 * @param  {boolean} sendToBranch? send this event to branchio also
 */
const clientCode =
  getClientCode(getCookieValue(NAVIGATION_FROM_APP_CODE) as APP_CODE_TYPE) ||
  Config.APP_CODE;

export function trackEvent(eventName: string, eventData?: Record<string, any>) {
  const utmParams = sessionStorage.getItem("utm_params");

  let finalEventData: Record<string, any> = {
    ...eventData,
    client_src: clientCode,
  };

  if (utmParams) {
    finalEventData = { ...finalEventData, ...JSON.parse(utmParams) };
  }

  if (window !== undefined && window.location?.href) {
    finalEventData.page_location = window.location?.href;
  }
  // track on mixpanel
  getMixpanelObj()?.track(eventName, finalEventData);
}

export function updateMixpanelUserProperties(
  userInfo: Record<string, any>,
  distinctKey: string,
) {
  const mixPanelObj = getMixpanelObj();
  if (mixPanelObj) {
    mixPanelObj.identify(userInfo[distinctKey]);
    mixPanelObj.registerSuperProperties(userInfo);
    mixPanelObj.getPeople().set(userInfo);
  }
}
